import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {UfFlowObjectStatusEnum} from "../enum/uf-flow-object-status.enum";

export class UfFlowObjectDto extends DtoDetail {

    public flowDtoId: number;
    public flowDtoName: string;

    public objectRoleDtoId: number;
    public objectRoleDtoName: string;

    public objectTypeDtoId: number;
    public objectTypeDtoName: string;
    public objectId: number;

    public addedInStepDtoId: number;
    public addedInStepDtoName: string;

    public status: UfFlowObjectStatusEnum;
    public selected: boolean;
    public orderIndex: number;

    public additionalData: string;

    public resolvedObject?: any;

    public getAdditionalDataObject(): any {
        if (!this.additionalData) {
            return {};
        }
        try {
            return JSON.parse(this.additionalData);
        } catch {
            return {};
        }
    }
}
